import { useEffect } from 'react';

import { useLocation } from 'react-router';

import { getWindowSafe } from '@change-corgi/core/window';

type UseScrollToHashOptions = Readonly<{
	elementId: string;
	targetHash: string;
	enabled?: boolean;
	offset?: number;
	behavior?: ScrollBehavior;
}>;

export function useScrollToHash({
	elementId,
	targetHash,
	enabled = true,
	offset = 0,
	behavior = 'smooth',
}: UseScrollToHashOptions): void {
	const { hash: navHash } = useLocation();
	const currentWindow = getWindowSafe();

	useEffect(() => {
		if (!enabled || !currentWindow) return;

		// Comparing React Router navigation hash
		if (navHash !== targetHash) return;

		// Wait for next frame to ensure DOM is ready, then add a small delay for layout to settle
		requestAnimationFrame(() => {
			setTimeout(() => {
				const element = currentWindow.document.getElementById(elementId);
				if (element) {
					const y = element.getBoundingClientRect().top + currentWindow.pageYOffset - offset;
					currentWindow.scrollTo({ top: y, behavior });
				}
			}, 100);
		});
	}, [enabled, currentWindow, navHash, targetHash, elementId, offset, behavior]);
}
